import { Fade, LinearProgress } from "@mui/material";

const styles = {
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    borderRadius: "inherit",
    height: "4px",
  },
};

const Progress = ({ loading }: { loading?: boolean }) => (
  <Fade in={loading} timeout={{ exit: 500 }}>
    <LinearProgress sx={styles.linearProgress} color="secondary" />
  </Fade>
);

export default Progress;
